import Programs from "./Sections/Programs";
import Ministers from "./Sections/Ministers";
import LatestNews from "./Sections/LatestNews";
import Carousel from "./Sections/Carousel";
import Intro from "./Sections/Intro";
import MotherChurch from "./Sections/MotherChurch";
import styles from "../Common.module.scss";
import Testimonies from "./Sections/Testimonies";
import { Helmet } from "react-helmet-async";

const Home = () => {
  return (
    <>
      <Helmet>
        <title>International Reformed Evangelical Church in Stockholm</title>
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English" />
        <meta
          name="description"
          content="We are Bible-believing, Reformed church that aims to share the Gospel to the people in Stockholm. Join us on Sundays for worship in English. Welcome to International Reformed Evangelical Church Stockholm (PRII Stockholm)."
        />
        <meta
          name="keywords"
          content="international church stockholm, reformed evangelical church, IREC stockholm, PRII stockholm, sunday service stockholm, christian church stockholm, protestant church stockholm, evangelical church, bible-believing church, church in stockholm, church in sweden, worship stockholm"
        />
        <meta
          itemProp="description"
          content="We are Bible-believing, Reformed church that aims to share the Gospel to the people in Stockholm. Join us on Sundays for worship in English. Welcome to International Reformed Evangelical Church Stockholm (PRII Stockholm)."
        />
        <meta
          name="og:title"
          property="og:title"
          content="International Reformed Evangelical Church in Stockholm"
        />
        <meta
          name="og:description"
          property="og:description"
          content="We are Bible-believing, Reformed church that aims to share the Gospel to the people in Stockholm. Join us on Sundays for worship in English. Welcome to International Reformed Evangelical Church Stockholm (PRII Stockholm)."
        />
        <meta name="og:type" property="og:type" content="website" />
        <meta
          name="og:url"
          property="og:url"
          content="https://irec-stockholm.org/"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="International Reformed Evangelical Church in Stockholm"
        />
        <meta
          name="twitter:description"
          content="We are Bible-believing, Reformed church that aims to share the Gospel to the people in Stockholm. Join us on Sundays for worship in English."
        />
        <meta
          name="og:image"
          property="og:image"
          content="https://irec-stockholm.org/carousel-01.png"
        />
        <meta
          name="og:image:alt"
          property="og:image:alt"
          content="International Reformed Evangelical Church in Stockholm - started 2007 with a small community of believers"
        />
        <meta name="og:image:width" property="og:image:width" content="1200" />
        <meta name="og:image:height" property="og:image:height" content="630" />
        <meta
          name="twitter:image"
          content="https://irec-stockholm.org/carousel-01.png"
        />
        <link rel="canonical" href="https://irec-stockholm.org/" />
      </Helmet>
      <div className={styles.page}>
        <Intro />
        <Carousel />
        <Programs />
        <Ministers />
        <LatestNews />
        <MotherChurch />
        <Testimonies />
      </div>
    </>
  );
};

export default Home;
